import { html } from "htm/preact";

export const InnerContainer = ({ children, className, hasPaddingSmall = true, hasPaddingLarge = true }) => {
  const paddingSmallX = hasPaddingSmall ? "px-5 md:px-8" : "px-0";
  const paddingSmallY = hasPaddingSmall ? "py-16" : "py-0";
  const paddingLargeX = hasPaddingLarge ? "lg:px-16" : "lg:px-0";
  const paddingLargeY = hasPaddingLarge ? "lg:py-16" : "lg:py-0";
  const padding = `${paddingSmallX} ${paddingSmallY} ${paddingLargeX} ${paddingLargeY}`;
  return html`<section class="${padding} ${className} lg:max-w-6xl mx-auto">${children}</section>`;
};

